export default "__VITE_ASSET__BoDy0Wd2__"